import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../services/supabase";
import { MorphingStatusLoader } from "../components/common/MorphingStatusLoader";

export const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Supabase automatically extracts the tokens from the URL hash
        const { error } = await supabase.auth.getSession();
        if (error) {
          console.error("Auth callback error:", error);
        }
      } catch (err) {
        console.error("Auth callback exception:", err);
      } finally {
        // Always redirect home — AuthProvider will pick up the session
        navigate("/", { replace: true });
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="auth-callback-page">
      <MorphingStatusLoader />
    </div>
  );
};
